// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"32":"b7cc23eb","109":"39bbcf8d","642":"d27e4f43","738":"0db0024c","960":"37c975cc"}[chunkId] + ".css";
};